<template>
  <div class="page-wrap" :style="{ backgroundImage : 'url(' + activeObj.pageBgc + ')'}">
    <div class="cardDraw-page-cotent">
      <div class="card-3d" v-for="(item,index) in activeObj.prizeData" :key="index" @click="onFlip(item,index)">
        <div class="card" :ref="'cardz'+index">
          <div class="font_content" :style="{ backgroundImage : 'url(' + item.zbcg + ')'}"></div>
        </div>
        <div class="card card-f-y" :ref="'cardf'+index"> 
          <div class="reverse_content" :style="{ backgroundImage : 'url(' + item.fbcg + ')'}">
            {{item.name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cardDraw",
  data() {
    return {
      surface: true,
      activeObj: {
        pageBgc: "/images/cardDraw-page-bg.png",
        prizeData: [//奖品
          {
            id: 1,
            name: 10,
            zbcg: "/images/cardDraw-item-bg.png",
            fbcg: "/images/cardDraw-item-active-bg.png",
            isFaceZ:true,
          },
          {
            id: 2,
            name: 20,
            zbcg: "/images/cardDraw-item-bg.png",
            fbcg: "/images/cardDraw-item-active-bg.png",
            isFaceZ:true,
          },
          {
            id: 3,
            name: 30,
            zbcg: "/images/cardDraw-item-bg.png",
            fbcg: "/images/cardDraw-item-active-bg.png",
            isFaceZ:true,
          },
        ],
      },
    };
  },
  mounted(){
    
  },
  methods: {
    //点击翻面
    onFlip(item,index) {
      var arr = ["rotateY(180deg)", "rotateY(0deg)"];
      this.$refs['cardz'+index][0].style.transform = item.isFaceZ ? arr[0] : arr[1];
      this.$refs['cardf'+index][0].style.transform = !item.isFaceZ ? arr[0] : arr[1];
      item.isFaceZ = !item.isFaceZ;
    },
    //翻牌之后保存奖品
    savePrize(){

    },
    //获取当前用户的抽奖信息
    getInfo(){

    }
  },
};
</script>

<style scoped lang="scss">
.page-wrap {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  padding-top: 316px;
  padding-left: 14px;
  background-size: 100% auto;
  background-position: top center;
  background-repeat: no-repeat;
  .cardDraw-page-cotent {
    height: 163px;
    .card-3d {
      float: left;
      width: 112px;
      height: 163px;
      position: relative;
      perspective: 1500px;
      background-color: transparent;
      transition: all 0.2s;
      .card {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        transition: all 1s;
        backface-visibility: hidden;
        &.card-f-y {
          transform: rotateY(-180deg);
        }
        &.card-f-x {
          transform: rotateX(-180deg);
        }
      }
    }
    .font_content,
    .reverse_content {
      width: 100%;
      height: 100%;
      border-radius: 3px;
      background-position: top center;
      background-repeat: no-repeat;
      background-size: 100% auto;
    }
  }
}
</style>